module.exports = __webpack_public_path__ + "assets/img/Trade-Glass-Depot-Website.da91686b.jpg";